module.exports = __webpack_public_path__ + "img/1_01.25ff0050.jpg";